export default function (axios) {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      console.log("error: ", error);
      return Promise.reject(error);
    }
  );
}
